const breadCrumbsStyle = Object.freeze({
  typeScale: Object.freeze([
    Object.freeze({ from: 's', until: 'xl', value: -1, }),
    Object.freeze({ from: 'xl', value: -2, }),
  ]),
});

export default breadCrumbsStyle;
